const getRate = (kitchen, machine) => {
  let rate;
  if (machine === 'Fritös') {
    if (kitchen.kitchen === 'Restaurang' || kitchen.kitchen === 'Förskola') {
      rate = 20
      return rate
    }
    rate = 14
    return rate
  } else if (machine === 'Grill') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 60
      return rate
    }
    rate = 42
    return rate
  } else if (machine === 'Kebabgrill') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 32
      return rate
    } else if (kitchen.kitchen === 'Centralkök') {
      rate = 28
      return rate
    }
    rate = 24
    return rate
  } else if (machine === 'Kokgryta') {
    if (kitchen.kitchen === 'Restaurang' || kitchen.kitchen === 'Förskola') {
      rate = 12
      return rate
    }
    rate = 14
    return rate
  } else if (machine === 'Kokpall') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 27
      return rate
    } else if (kitchen.kitchen === 'Centralkök' || kitchen.kitchen === 'Förskola') {
      rate = 21
      return rate
    }
    rate = 21
    return rate
  } else if (machine === 'Kombiugn') {
    if (kitchen.kitchen === 'Centralkök') {
      rate = 8
      return rate
    } else if (kitchen.kitchen === 'Förskola') {
      rate = 12
      return rate
    }
    rate = 10
    return rate
  } else if (machine === 'Kombiugn') {
    if (kitchen.kitchen === 'Centralkök') {
      rate = 8
      return rate
    } else if (kitchen.kitchen === 'Förskola') {
      rate = 12
      return rate
    }
    rate = 10
    return rate
  } else if (machine === 'Konvektionsugn') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 7
      return rate
    } else if (kitchen.kitchen === 'Förskola') {
      rate = 6
      return rate
    }
    rate = 5
    return rate
  } else if (machine === 'Lightfryer') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 11
      return rate
    }
    rate = 8
    return rate
  } else if (machine === 'Pastakokare') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 14
      return rate
    }
    rate = 12
    return rate
  } else if (machine === 'Pizzaugn') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 11
      return rate
    }
    rate = 8
    return rate
  } else if (machine === 'Plancha') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 54
      return rate
    }
    rate = 42
    return rate
  } else if (machine === 'Salamander') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 32
      return rate
    } else if (kitchen.kitchen === 'Skola') {
      rate = 18
      return rate
    } else if (kitchen.kitchen === 'Förskola') {
      rate = 35
      return rate
    }
    rate = 21
    return rate
  } else if (machine === 'Spis,el') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 24
      return rate
    }
    rate = 21
    return rate
  } else if (machine === 'Spis,gas') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 28
      return rate
    }
    rate = 24
    return rate
  } else if (machine === 'Spis,induktion') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 20
      return rate
    }
    rate = 18
    return rate
  } else if (machine === 'Stekbord/Stekhäll') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 27
      return rate
    } else if (kitchen.kitchen === 'Centralkök' || kitchen.kitchen === 'Förskola') {
      rate = 21
      return rate
    }
    rate = 24
    return rate
  } else if (machine === 'Stekugn') {
    if (kitchen.kitchen === 'Centralkök') {
      rate = 5
      return rate
    } else if (kitchen.kitchen === 'Förskola') {
      rate = 10
      return rate
    }
    rate = 3
    return rate
  } else if (machine === 'Tryckkokskåp') {
    if (kitchen.kitchen === 'Skola') {
      rate = 5
      return rate
    } else if (kitchen.kitchen === 'Förskola') {
      rate = 3
      return rate
    }
    rate = 4
    return rate
  } else if (machine === 'Variocooking center') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 27
      return rate
    } else if (kitchen.kitchen === 'Centralkök' || kitchen.kitchen === 'Förskola') {
      rate = 21
      return rate
    }
    rate = 24
    return rate
  } else if (machine === 'Vattenbad') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 14
      return rate
    }
    rate = 12
    return rate
  } else if (machine === 'Wok') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 40
      return rate
    } else if (kitchen.kitchen === 'Skola' || kitchen.kitchen === 'Förskola') {
      rate = 60
      return rate
    }
    rate = 54
    return rate
  } else if (machine === 'Värmeri') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 14
      return rate
    }
    rate = 12
    return rate
  } else if (machine === 'Grovdisk med/utan granulat') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 12
      return rate
    }
    rate = 10
    return rate
  } else if (machine === 'Huvdisk,underbänk') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 15
      return rate
    }
    rate = 14
    return rate
  } else if (machine === 'Tunneldisk') {
    if (kitchen.kitchen === 'Restaurang') {
      rate = 9
      return rate
    }
    rate = 8
    return rate
  }
}
export default getRate;
